import { getAppearanceFeeInfo, getAppearanceTypesForCourt } from "@/lib/vla-fees-data";
import {
  BAIL_TABLE_B_ADDITIONS,
  COUNTY_COURT_BAIL_CLAIM_ROWS,
  SUPREME_COURT_BAIL_CLAIM_ROWS,
  INDICTABLE_COMMITTAL_CLAIM_ROWS,
  COUNTY_COURT_INDICTABLE_CLAIM_ROWS,
  SUPREME_COURT_INDICTABLE_CLAIM_ROWS,
  CHILDRENS_COURT_INDICTABLE_CLAIM_ROWS,
  COUNTY_COURT_SENTENCE_APPEAL_CLAIM_ROWS,
  COUNTY_COURT_CONVICTION_APPEAL_CLAIM_ROWS,
  SUPREME_COURT_BREACH_CLAIM_ROWS,
  COURT_OF_APPEAL_CLAIM_ROWS,
  COURT_OF_APPEAL_DPP_CLAIM_ROWS,
  INTERLOCUTORY_APPEAL_CLAIM_ROWS,
  HIGH_COURT_CLAIM_ROWS,
  MENTAL_IMPAIRMENT_CC_CLAIM_ROWS,
  MENTAL_IMPAIRMENT_SC_CLAIM_ROWS,
  CHIEF_EXAMINER_CLAIM_ROWS,
  SERIOUS_OFFENDERS_CC_CLAIM_ROWS,
  SERIOUS_OFFENDERS_SC_CLAIM_ROWS,
  FAMILY_VIOLENCE_CLAIM_ROWS,
  PSIO_CLAIM_ROWS,
} from "./aidPlannerFeeSchedules.js";

const PLANNER_TO_BACKSHEET_COURT = {
  "Children's Court": "Children's Court",
  "Magistrates' Court": "Magistrates Court",
  "County Court": "County Court",
  "Supreme Court": "Supreme Court",
  "Court of Appeal": "Court of appeal",
  "High Court": "High Court",
  Other: "Other",
};

const SINGLE_SUMMARY_APPEARANCE_LOOKUP = {
  "CONSOL CONT MENTION": {
    appearanceType: "CONSOL CONT MENTION",
    feeType: "CONSOL CONT MENTION",
    amountLabel: "1 APPEARANCE(s) @ $581.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
  },
  PREPARATION: {
    appearanceType: "PREPARATION",
    feeType: "PREPARATION",
    amountLabel: "LUMP SUM $484.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
  },
  APPEARANCE: {
    appearanceType: "APPEARANCE",
    feeType: "APPEARANCE",
    amountLabel: "3 DAY(s) @ $484.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: ["APPEARANCE", "PLEA"],
  },
  "DEFEND/CONTEST DAILY FEE": {
    appearanceType: "DEFEND/CONTEST DAILY FEE",
    feeType: "DEFEND/CONTEST DAILY FEE",
    amountLabel: "5 DAY(s) @ $1099.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 5,
    allocationUnit: "day",
    trackerAliases: ["DEFEND/CONTEST DAILY FEE", "CONTESTED HEARING"],
  },
  "CONTEST MENTION": {
    appearanceType: "CONTEST MENTION",
    feeType: "CONTEST MENTION",
    amountLabel: "3 MENTION(s) @ $332.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 3,
    allocationUnit: "mention",
  },
  "PLEA AT CONTEST MENTION": {
    appearanceType: "PLEA AT CONTEST MENTION",
    feeType: "PLEA AT CONTEST MENTION",
    amountLabel: "1 DAY(s) @ $318.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "day",
  },
  "CRED/DRUG COURT MENTION": {
    appearanceType: "CRED/DRUG COURT MENTION",
    feeType: "CRED/DRUG COURT MENTION",
    amountLabel: "ATTENDANCE $185.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "attendance",
  },
  "JAIL CONFERENCE": {
    appearanceType: "JAIL CONFERENCE",
    feeType: "JAIL CONFERENCE",
    amountLabel: "ATTENDANCE $185.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "attendance",
  },
  ADJOURNMENT: {
    appearanceType: "ADJOURNMENT",
    feeType: "ADJOURNMENT",
    amountLabel: "2 APPEARANCE(s) @ $318.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
  },
  "BRIEF SENTENCE INDICATION": {
    appearanceType: "BRIEF SENTENCE INDICATION",
    feeType: "BRIEF SENTENCE INDICATION",
    amountLabel: "1 DAY(s) @ $484.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "day",
  },
  "APPEAR AT SENTENCE": {
    appearanceType: "APPEAR AT SENTENCE",
    feeType: "APPEAR AT SENTENCE",
    amountLabel: "2 APPEARANCE(s) @ $318.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: ["APPEAR AT SENTENCE", "SENTENCE"],
  },
  "TRAVEL FEE": {
    appearanceType: "TRAVEL FEE",
    feeType: "TRAVEL FEE",
    amountLabel: "2000 KILOMETRE(s) @ $0.83",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 2000,
    allocationUnit: "kilometre",
  },
  "OVERNIGHT FEE": {
    appearanceType: "OVERNIGHT FEE",
    feeType: "OVERNIGHT FEE",
    amountLabel: "5 NIGHT(s) @ $394.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 5,
    allocationUnit: "night",
  },
  "TAPE TRANSCRIPTION": {
    appearanceType: "TAPE TRANSCRIPTION",
    feeType: "TAPE TRANSCRIPTION",
    amountLabel: "3 TAPE(s) @ $99.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 3,
    allocationUnit: "tape",
  },
  "FOI/TITLE LODG/SEARCH FEE": {
    appearanceType: "FOI/TITLE LODG/SEARCH FEE",
    feeType: "FOI/TITLE LODG/SEARCH FEE",
    amountLabel: "MAXIMUM LIMIT $668.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "limit",
  },
  "SERVICE/FILING/COND MONEY": {
    appearanceType: "SERVICE/FILING/COND MONEY",
    feeType: "SERVICE/FILING/COND MONEY",
    amountLabel: "MAXIMUM LIMIT $617.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "limit",
  },
  "SPECIAL MENTION - SUMMARY": {
    appearanceType: "SPECIAL MENTION - SUMMARY",
    feeType: "SPECIAL MENTION - SUMMARY",
    amountLabel: "2 MENTION(s) @ $185.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 2,
    allocationUnit: "mention",
  },
  "FIRST REMAND HEARING": {
    appearanceType: "FIRST REMAND HEARING",
    feeType: "FIRST REMAND HEARING",
    amountLabel: "1 APPEARANCE(s) @ $231.00",
    table: "Single Summary grant",
    note: "Effective 27/01/2026 to current.",
    effectiveFrom: "27/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: ["FIRST REMAND HEARING"],
  },
  "SUMMARY CRIME MENTION": {
    appearanceType: "SUMMARY CRIME MENTION",
    feeType: "SUMMARY CRIME MENTION",
    amountLabel: "2 APPEARANCE(s) @ $185.00",
    table: "Single Summary grant",
    note: "Effective 30/03/2026 to current.",
    effectiveFrom: "30/03/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: ["SUMMARY CRIME MENTION", "MENTION"],
  },

  // --- Table A: Urgent preparation ---
  "URGENT PREPARATION": {
    appearanceType: "URGENT PREPARATION",
    feeType: "URGENT PREPARATION",
    amountLabel: "LUMP SUM $277.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Applies where aid is requested no earlier than the day before the substantive hearing, or where an urgent grant is in receipt.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: ["URGENT PREPARATION", "URGENT PREP"],
  },

  // --- Table A: Consolidated charge fees (initial grant — not CRSM8 extension) ---
  "CONSOLIDATED PREPARATION": {
    appearanceType: "CONSOLIDATED PREPARATION",
    feeType: "CONSOLIDATED PREPARATION",
    amountLabel: "LUMP SUM $579.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Applies where two or more briefs are consolidated and heard together (specific grant required).",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: ["CONSOLIDATED PREPARATION", "CONSOL PREPARATION"],
  },
  "CONSOLIDATED URGENT PREPARATION": {
    appearanceType: "CONSOLIDATED URGENT PREPARATION",
    feeType: "CONSOLIDATED URGENT PREPARATION",
    amountLabel: "LUMP SUM $348.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Urgent grant consolidated preparation fee.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: ["CONSOLIDATED URGENT PREPARATION", "CONSOL URGENT PREP"],
  },
  "CONSOLIDATED APPEARANCE": {
    appearanceType: "CONSOLIDATED APPEARANCE",
    feeType: "CONSOLIDATED APPEARANCE",
    amountLabel: "3 DAY(s) @ $579.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Consolidated daily appearance fee.",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: ["CONSOLIDATED APPEARANCE", "CONSOL APPEARANCE"],
  },
  "CONSOLIDATED ADJOURNMENT": {
    appearanceType: "CONSOLIDATED ADJOURNMENT",
    feeType: "CONSOLIDATED ADJOURNMENT",
    amountLabel: "2 APPEARANCE(s) @ $369.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Consolidated appearance on sentence or adjournment.",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: ["CONSOLIDATED ADJOURNMENT", "CONSOL ADJ", "CONSOLIDATED SENTENCE", "CONSOL SENTENCE"],
  },
  "CONSOLIDATED PLEA AT CONTEST MENTION": {
    appearanceType: "CONSOLIDATED PLEA AT CONTEST MENTION",
    feeType: "CONSOLIDATED PLEA AT CONTEST MENTION",
    amountLabel: "1 DAY(s) @ $369.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Consolidated plea fee where plea heard at contest mention.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "day",
    trackerAliases: ["CONSOLIDATED PLEA AT CONTEST MENTION", "CONSOL PLEA"],
  },

  // --- Table A: Mention hearing ---
  "MENTION HEARING": {
    appearanceType: "MENTION HEARING",
    feeType: "MENTION HEARING",
    amountLabel: "3 APPEARANCE(s) @ $185.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Standard appearance at mention hearing.",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: ["MENTION HEARING", "APPEARANCE AT MENTION HEARING"],
  },

  // --- Table A: Assessment and Referral Court (ARC) ---
  "ARC RATIFICATION HEARING": {
    appearanceType: "ARC RATIFICATION HEARING",
    feeType: "ARC RATIFICATION HEARING",
    amountLabel: "1 APPEARANCE(s) @ $332.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Assessment and Referral Court – Individual Support Plan Ratification hearing.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: ["ARC RATIFICATION HEARING", "ARC RATIFICATION", "ARC INDIVIDUAL SUPPORT PLAN"],
  },
  "ARC REVIEW HEARING": {
    appearanceType: "ARC REVIEW HEARING",
    feeType: "ARC REVIEW HEARING",
    amountLabel: "3 APPEARANCE(s) @ $185.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Assessment and Referral Court Review Hearing.",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: ["ARC REVIEW HEARING", "ARC REVIEW"],
  },

  // --- Table A: Children's Court only ---
  "GROUP CONFERENCE": {
    appearanceType: "GROUP CONFERENCE",
    feeType: "GROUP CONFERENCE",
    amountLabel: "1 CONFERENCE @ $464.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Children's Court only – group conference held during work hours.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "conference",
    trackerAliases: ["GROUP CONFERENCE", "GROUP CONFERENCE WORK HOURS"],
  },
  "GROUP CONFERENCE (AFTER HOURS)": {
    appearanceType: "GROUP CONFERENCE (AFTER HOURS)",
    feeType: "GROUP CONFERENCE (AFTER HOURS)",
    amountLabel: "1 CONFERENCE @ $594.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Children's Court only – group conference held outside work hours.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "conference",
    trackerAliases: ["GROUP CONFERENCE (AFTER HOURS)", "GROUP CONFERENCE AFTER HOURS"],
  },
  "YCO PLANNING MEETING": {
    appearanceType: "YCO PLANNING MEETING",
    feeType: "YCO PLANNING MEETING",
    amountLabel: "1 MEETING @ $358.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Children's Court only – Youth Control Order planning meeting.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "meeting",
    trackerAliases: ["YCO PLANNING MEETING", "YOUTH CONTROL ORDER PLANNING", "YCO PLANNING"],
  },
  "YCO MONITORING HEARING": {
    appearanceType: "YCO MONITORING HEARING",
    feeType: "YCO MONITORING HEARING",
    amountLabel: "3 APPEARANCE(s) @ $185.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Children's Court only – Youth Control Order reporting and monitoring hearing.",
    effectiveFrom: "01/01/2026",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: ["YCO MONITORING HEARING", "YOUTH CONTROL ORDER MONITORING", "YCO MONITORING"],
  },
  "YCO MONITORING (OPPOSE VARIATION)": {
    appearanceType: "YCO MONITORING (OPPOSE VARIATION)",
    feeType: "YCO MONITORING (OPPOSE VARIATION)",
    amountLabel: "2 APPEARANCE(s) @ $318.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Children's Court only – YCO monitoring hearing to oppose variation to a significantly more restrictive order.",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: ["YCO MONITORING (OPPOSE VARIATION)", "YCO OPPOSE VARIATION"],
  },
  "YCO BREACH": {
    appearanceType: "YCO BREACH",
    feeType: "YCO BREACH",
    amountLabel: "1 APPEARANCE(s) @ $484.00",
    table: "Single Summary grant",
    note: "Effective 1/01/2026 to current. Children's Court only – breach or revocation of a Youth Control Order.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: ["YCO BREACH", "YOUTH CONTROL ORDER BREACH", "YCO REVOCATION"],
  },
  "APPLICATION FOR SUMMARY JURISDICTION": {
    appearanceType: "APPLICATION FOR SUMMARY JURISDICTION",
    feeType: "APPLICATION FOR SUMMARY JURISDICTION",
    amountLabel: "1 APPEARANCE @ $890.00",
    table: "Single Summary grant",
    note: "Effective 19/10/2026 to current (was $445). Children's Court only.",
    effectiveFrom: "19/10/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: ["APPLICATION FOR SUMMARY JURISDICTION", "SUMMARY JURISDICTION APPLICATION"],
  },
};

const SINGLE_SUMMARY_APPEARANCE_OPTIONS = Object.keys(SINGLE_SUMMARY_APPEARANCE_LOOKUP);

const COUNTY_COURT_BREACH_CLAIM_ROWS = [
  {
    appearanceType: "PREPARATION",
    feeType: "PREPARATION",
    amountLabel: "LUMP SUM $1,028.00",
    table: "County Court Breach grant",
    note: "Solicitor preparation (5.5 hours), Table J.",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: ["PREPARATION", "SOLICITOR PREPARATION"],
  },
  {
    appearanceType: "DAILY HEARING FEE",
    feeType: "DAILY HEARING FEE",
    amountLabel: "3 APPEARANCE(s) @ $1,087.00",
    table: "County Court Breach grant",
    note: "County Court Breach daily hearing fee allocation.",
    allocationCount: 3,
    allocationUnit: "appearance",
    trackerAliases: ["DAILY HEARING FEE", "TRIAL", "TRIAL (FIRST DAY)", "TRIAL (SUBSEQUENT DAY)", "CONTESTED HEARING"],
  },
  {
    appearanceType: "MENTION",
    feeType: "MENTION",
    amountLabel: "2 APPEARANCE(s) @ $297.00",
    table: "County Court Breach grant",
    note: "County Court Breach mention allocation.",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: ["MENTION", "DIRECTIONS HEARING / MENTION / CALLOVER", "DIRECTIONS HEARING", "FIRST DIRECTIONS HEARING"],
  },
  {
    appearanceType: "APPEAR AT SENTENCE",
    feeType: "APPEAR AT SENTENCE",
    amountLabel: "2 APPEARANCE(s) @ $356.00",
    table: "County Court Breach grant",
    note: "County Court Breach sentence allocation.",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: ["APPEAR AT SENTENCE", "SENTENCE", "RETURN FOR SENTENCE"],
  },
];

// Consolidated Extension uplift fees ("Increase to Consol" extension)
const CONSOL_EXTENSION_CRSM8_CLAIM_ROWS = [
  {
    appearanceType: "CONSOL PREPARATION",
    feeType: "CONSOL PREPARATION",
    amountLabel: "LUMP SUM $95.00",
    table: "Consolidated Extension – Uplift Fees",
    note: "Effective from Consol Extension start date to current.",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: ["CRSM8 PREPARATION", "CRSM8PREPARATION"],
  },
  {
    appearanceType: "CONSOL APPEARANCE",
    feeType: "CONSOL APPEARANCE",
    amountLabel: "3 DAY(s) @ $95.00",
    table: "Consolidated Extension – Uplift Fees",
    note: "Effective from Consol Extension start date to current.",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: ["CRSM8 APPEARANCE", "CRSM8APPEARANCE"],
  },
  {
    appearanceType: "CONSOL PLEA AT CONTEST MENTION",
    feeType: "CONSOL PLEA AT CONTEST MENTION",
    amountLabel: "LUMP SUM $51.00",
    table: "Consolidated Extension – Uplift Fees",
    note: "Effective from Consol Extension start date to current.",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: ["CRSM8 PLEA AT CONTEST MENTION"],
  },
  {
    appearanceType: "CONSOL ADJOURNMENT",
    feeType: "CONSOL ADJOURNMENT",
    amountLabel: "2 APPEARANCE(s) @ $51.00",
    table: "Consolidated Extension – Uplift Fees",
    note: "Effective from Consol Extension start date to current.",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: ["CRSM8 ADJOURNMENT"],
  },
  {
    appearanceType: "CONSOL BRIEF SENTENCE INDICATION",
    feeType: "CONSOL BRIEF SENTENCE INDICATION",
    amountLabel: "3 DAY(s) @ $95.00",
    table: "Consolidated Extension – Uplift Fees",
    note: "Effective from Consol Extension start date to current.",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: ["CRSM8 BRIEF SENTENCE INDICATION"],
  },
  {
    appearanceType: "CONSOL APPEAR AT SENTENCE",
    feeType: "CONSOL APPEAR AT SENTENCE",
    amountLabel: "2 APPEARANCE(s) @ $51.00",
    table: "Consolidated Extension – Uplift Fees",
    note: "Effective from Consol Extension start date to current.",
    allocationCount: 2,
    allocationUnit: "appearance",
    trackerAliases: ["CRSM8 APPEAR AT SENTENCE"],
  },
];

function getActiveScopesList(aidTypeList = []) {
  let rawList = [];
  if (aidTypeList && typeof aidTypeList === "object" && !Array.isArray(aidTypeList)) {
    const planner = aidTypeList;
    // Union: top-level aidTypeList + top-level aidType + all extension aidTypes
    // (Extension uploads overwrite planner.aid.aidType, but the initial grant type
    //  is preserved in extensions[0].aidType — we need all of them for tracker matching)
    rawList = [
      ...(planner?.aid?.aidTypeList || []),
      planner?.aid?.aidType || "",
      ...(planner?.aid?.extensions || []).map((e) => e.aidType || ""),
    ].filter(Boolean);
  } else {
    rawList = Array.isArray(aidTypeList) ? [...aidTypeList] : [aidTypeList];
  }

  // Split any consolidated string lists like "A, B and C"
  const list = [];
  for (const item of rawList) {
    if (typeof item === "string") {
      const parts = item
        .split(",")
        .flatMap((x) => x.split(/\s+and\s+(?!or\b)/i))
        .map((x) => x.trim())
        .filter(Boolean);
      list.push(...parts);
    } else {
      list.push(item);
    }
  }
  return list;
}


function hasSummarySingleAidType(aidTypeList = []) {
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const normalized = `${item || ""}`.toLowerCase();
    return (
      normalized.includes("summary single") ||
      normalized.includes("single summary") ||
      normalized.includes("summary - up to five defended days") ||
      normalized.includes("summary hearing-lump sum") ||
      normalized.includes("summary lump sum")
    );
  });
}

function hasBailAidType(aidTypeList = []) {
  // Table B — Magistrates'/Children's Court bail only (excludes CC and SC bail)
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("bail") && !n.includes("county court") && !n.includes("supreme court");
  });
}

function hasCountyCourtBailAidType(aidTypeList = []) {
  // Table C — County Court bail
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("bail") && n.includes("county court");
  });
}

function hasSupremeCourtBailAidType(aidTypeList = []) {
  // Table D — Supreme Court bail
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("bail") && n.includes("supreme court");
  });
}

function hasChildrensCourtBailAidType(aidTypeList = []) {
  // Intensive Bail Scheme (Table B addition) — Children's Court bail only
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("bail") && (n.includes("children") || n.includes("childrens") || n.includes("children's"));
  });
}

function hasIndictableCommittalAidType(aidTypeList = []) {
  // Table E — Indictable committal (Magistrates'/Children's Court stage)
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (
      n.includes("committal") ||
      (n.includes("indictable") && !n.includes("county court") && !n.includes("supreme court") && !n.includes("children"))
    );
  });
}

function hasCountyCourtIndictableAidType(aidTypeList = []) {
  // Table F (CC) — County Court indictable
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (n.includes("county court") && n.includes("indictable"))
      || (isFitnessInvestigation(n) && !n.includes("supreme court"));
  });
}

function hasSupremeCourtIndictableAidType(aidTypeList = []) {
  // Table F (SC) — Supreme Court indictable
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (n.includes("supreme court") && n.includes("indictable") && !n.includes("breach"))
      || (isFitnessInvestigation(n) && n.includes("supreme court"));
  });
}

function hasChildrensCourtIndictableAidType(aidTypeList = []) {
  // Table F(i) — Children's Court serious indictable matters
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("children") && n.includes("indictable");
  });
}

function hasCountyCourtSentenceAppealAidType(aidTypeList = []) {
  // Table G — County Court sentence appeal
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (
      n.includes("county court") &&
      n.includes("sentence appeal")
    );
  });
}

function hasCountyCourtConvictionAppealAidType(aidTypeList = []) {
  // Table H — County Court appeal (conviction + sentence)
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (
      n.includes("county court") &&
      (n.includes("conviction") || (n.includes("appeal") && !n.includes("sentence appeal")))
    );
  });
}

function hasSupremeCourtBreachAidType(aidTypeList = []) {
  // Table J (SC) — Supreme Court breach
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("supreme court") && n.includes("breach");
  });
}

function hasCourtOfAppealAidType(aidTypeList = []) {
  // Table K — Court of Appeal (convicted person)
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (
      n.includes("court of appeal") &&
      !n.includes("dpp") &&
      !n.includes("director of public prosecution") &&
      !n.includes("interlocutory")
    );
  });
}

function hasCourtOfAppealDPPAidType(aidTypeList = []) {
  // Table K(i) — Court of Appeal DPP
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (
      (n.includes("court of appeal") || n.includes("appeal")) &&
      (n.includes("dpp") || n.includes("director of public prosecution"))
    );
  });
}

function hasInterlocutoryAppealAidType(aidTypeList = []) {
  // Table K(ii) — Interlocutory appeal
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("interlocutory");
  });
}

function hasHighCourtAidType(aidTypeList = []) {
  // Table L — High Court
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("high court");
  });
}

// Table T (CMIA) is only for a client who has previously been found unfit and is now on an
// order that is to be reviewed. A client whose fitness is being investigated is on a standard
// trial grant (Table F), so an aid type naming a fitness investigation loads the trial rows,
// not Table T. "Unfitness" (as in the Act's name) is not a fitness investigation.
function isFitnessInvestigation(n = "") {
  return /\bfitness\b/.test(n) && !/\bunfit|\breview/.test(n);
}

function isCmiaAidType(n = "") {
  return (n.includes("mental impairment") || n.includes("cmia")) && !isFitnessInvestigation(n);
}

function hasMentalImpairmentCCAidType(aidTypeList = []) {
  // Table T (CC) — Mental Impairment Act County Court
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return isCmiaAidType(n) && !n.includes("supreme court");
  });
}

function hasMentalImpairmentSCAidType(aidTypeList = []) {
  // Table T (SC) — Mental Impairment Act Supreme Court
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return isCmiaAidType(n) && n.includes("supreme court");
  });
}

function hasChiefExaminerAidType(aidTypeList = []) {
  // Table Y — Chief Examiner / Witness Assistance
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("chief examiner") || n.includes("witness assistance");
  });
}

function hasSeriousOffendersCCAidType(aidTypeList = []) {
  // Table Z (CC) — Serious Offenders Act County Court
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (
      (n.includes("serious offender") || n.includes("soa 2018") || n.includes("detention order") || n.includes("supervision order")) &&
      (n.includes("county court") || (!n.includes("supreme court")))
    );
  });
}

function hasSeriousOffendersSCAidType(aidTypeList = []) {
  // Table Z (SC) — Serious Offenders Act Supreme Court
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (
      (n.includes("serious offender") || n.includes("soa 2018") || n.includes("detention order") || n.includes("supervision order")) &&
      n.includes("supreme court")
    );
  });
}

function hasFamilyViolenceAidType(aidTypeList = []) {
  // Table A4 — Family Violence Protection Act
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return (
      n.includes("family violence") ||
      n.includes("fvpa") ||
      (n.includes("intervention order") && !n.includes("personal safety"))
    );
  });
}

function hasPSIOAidType(aidTypeList = []) {
  // Table A5 — Personal Safety Intervention Order Act
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const n = `${item || ""}`.toLowerCase();
    return n.includes("personal safety") || n.includes("psio");
  });
}

function hasPsychologicalAidType(aidTypeList = []) {
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const normalized = `${item || ""}`.toLowerCase();
    return normalized.includes("psychol") || normalized.includes("mental");
  });
}

function hasCountyCourtBreachAidType(aidTypeList = []) {
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const normalized = `${item || ""}`.toLowerCase();
    return normalized.includes("county court breach") || normalized.includes("breach proceedings - county court");
  });
}

function hasConsolExtensionAidType(aidTypeList = []) {
  const list = getActiveScopesList(aidTypeList);
  return list.some((item) => {
    const normalized = `${item || ""}`.toLowerCase();
    return normalized.includes("increase to consol") || normalized.includes("consol");
  });
}

export const BAIL_CLAIM_ROWS = [
  {
    appearanceType: "BAIL PREPARATION",
    feeType: "BAIL PREPARATION",
    amountLabel: "LUMP SUM $362.00",
    table: "Table B – Bail Magistrates'/Children's Court",
    note: "Effective 19/10/2026 to current (was $226).",
    effectiveFrom: "19/10/2026",
    allocationCount: 1,
    allocationUnit: "lump sum",
    trackerAliases: ["BAIL PREPARATION", "BAIL PREP"],
  },
  {
    appearanceType: "BAIL APPEARANCE",
    feeType: "BAIL APPEARANCE",
    amountLabel: "3 DAY(s) @ $557.00",
    table: "Table B – Bail Magistrates'/Children's Court",
    note: "Effective 19/10/2026 to current (was $484).",
    effectiveFrom: "19/10/2026",
    allocationCount: 3,
    allocationUnit: "day",
    trackerAliases: ["BAIL APPEARANCE", "BAIL APP"],
  },
  {
    appearanceType: "BAIL TRAVEL FEE",
    feeType: "BAIL TRAVEL FEE",
    amountLabel: "600 KILOMETRE(s) @ $0.83",
    table: "Table B – Bail Magistrates'/Children's Court",
    note: "Effective 1/01/2026 to current.",
    effectiveFrom: "01/01/2026",
    allocationCount: 600,
    allocationUnit: "kilometre",
    trackerAliases: ["BAIL TRAVEL FEE", "BAIL TRAVEL"],
  },
  {
    appearanceType: "BAIL OVERNIGHT FEE",
    feeType: "BAIL OVERNIGHT FEE",
    amountLabel: "2 NIGHT(s) @ $394.00",
    table: "Table B – Bail Magistrates'/Children's Court",
    note: "Effective 1/01/2026 to current.",
    effectiveFrom: "01/01/2026",
    allocationCount: 2,
    allocationUnit: "night",
    trackerAliases: ["BAIL OVERNIGHT FEE", "BAIL OVERNIGHT"],
  },
  {
    appearanceType: "BAIL FOI/TITLE LODG/SEARCH FEE",
    feeType: "BAIL FOI/TITLE LODG/SEARCH FEE",
    amountLabel: "MAXIMUM LIMIT $668.00",
    table: "Table B – Bail Magistrates'/Children's Court",
    note: "Effective 1/01/2026 to current.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "limit",
    trackerAliases: ["FOI/TITLE LODG/SEARCH FEE", "BAIL FOI/TITLE LODG/SEARCH FEE"],
  },
  {
    appearanceType: "BAIL SERVICE/FILING/COND MONEY",
    feeType: "BAIL SERVICE/FILING/COND MONEY",
    amountLabel: "MAXIMUM LIMIT $617.00",
    table: "Table B – Bail Magistrates'/Children's Court",
    note: "Effective 17/01/2026 to current.",
    effectiveFrom: "17/01/2026",
    allocationCount: 1,
    allocationUnit: "limit",
    trackerAliases: ["SERVICE/FILING/COND MONEY", "BAIL SERVICE/FILING/COND MONEY"],
  },
  {
    appearanceType: "BAIL FIRST REMAND HEARING",
    feeType: "BAIL FIRST REMAND HEARING",
    amountLabel: "1 APPEARANCE(s) @ $231.00",
    table: "Table B – Bail Magistrates'/Children's Court",
    note: "Effective 1/01/2026 to current.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "appearance",
    trackerAliases: ["FIRST REMAND HEARING", "BAIL FIRST REMAND HEARING"],
  },
];

export const PSYCHOLOGICAL_CLAIM_ROWS = [
  {
    appearanceType: "PSYCHOL-NON ATTENDANCE",
    feeType: "PSYCHOL-NON ATTENDANCE",
    amountLabel: "MAXIMUM LIMIT $82.00",
    table: "Psychological Assessment (DISB51)",
    note: "Effective 1/01/2026 to current.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "limit",
    trackerAliases: ["PSYCHOL-NON ATTENDANCE", "PSYCHOLOGICAL NON-ATTENDANCE"],
  },
  {
    appearanceType: "PSYCHOL REP+JAIL VISIT",
    feeType: "PSYCHOL REP+JAIL VISIT",
    amountLabel: "MAXIMUM LIMIT $850.00",
    table: "Psychological Assessment (DISB51)",
    note: "Effective 1/01/2026 to current.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "limit",
    trackerAliases: ["PSYCHOL REP+JAIL VISIT", "PSYCHOLOGICAL REPORT AND JAIL VISIT"],
  },
  {
    // "PSYCHOLOGICAL REPORT" is the ATLAS work type on a claim for a psychologist's assessment
    // and report without a jail conference (Table S, $746).
    appearanceType: "PSYCHOLOGICAL REPORT",
    feeType: "PSYCHOLOGICAL REPORT",
    amountLabel: "MAXIMUM LIMIT $746.00",
    table: "Psychological Assessment (DISB51)",
    note: "Assessment and report without jail conference, Table S. Effective 1/01/2026 to current.",
    effectiveFrom: "01/01/2026",
    allocationCount: 1,
    allocationUnit: "limit",
    trackerAliases: ["PSYCHOLOGICAL REPORT", "PSYCHOL REPORT"],
  },
];


export function getBacksheetCourtName(courtName) {
  return PLANNER_TO_BACKSHEET_COURT[courtName] || "";
}

export function getPlannerAppearanceOptions(courtName, aidTypeList = [], currentValue = "") {
  // Derive options from all active tracker rows for this planner's grant types
  const trackerRows = getClaimTrackerRowsForAidType(aidTypeList);
  let options = [];

  if (trackerRows.length > 0) {
    options = trackerRows.map((row) => row.appearanceType);
  } else {
    // Fallback: use backsheet court appearance types
    const backsheetCourt = getBacksheetCourtName(courtName);
    if (backsheetCourt) {
      options = getAppearanceTypesForCourt(backsheetCourt).map((option) => option.label);
    }
  }

  options = Array.from(new Set(options));

  if (currentValue && !options.includes(currentValue)) {
    options = [currentValue, ...options];
  }

  return options;
}

export function getPlannerAppearanceFeeInfo(courtName, appearanceType, aidTypeList = []) {
  const trackerRows = getClaimTrackerRowsForAidType(aidTypeList);

  if (trackerRows.length > 0) {
    const normalizedTarget = normalizeTrackerValue(appearanceType);

    // First: exact appearanceType match
    const exactMatch = trackerRows.find((row) => row.appearanceType === appearanceType);
    if (exactMatch) return exactMatch;

    // Second: alias match (normalised)
    for (const row of trackerRows) {
      const aliases = [row.appearanceType, row.feeType, ...(row.trackerAliases || [])]
        .map(normalizeTrackerValue)
        .filter(Boolean);
      if (aliases.includes(normalizedTarget)) return row;
    }
  }

  // Fallback: backsheet court fee info
  const backsheetCourt = getBacksheetCourtName(courtName);
  if (!backsheetCourt || !appearanceType) return null;
  return getAppearanceFeeInfo(backsheetCourt, appearanceType);
}

export function applyPlannerAppearanceFeeDefaults(claim, courtName, appearanceType, aidTypeList = []) {
  const feeInfo = getPlannerAppearanceFeeInfo(courtName, appearanceType, aidTypeList);
  if (!feeInfo) {
    return {
      ...claim,
      appearanceType,
      feeType: claim.feeType || "",
      feeAmount: "",
      feeTable: "",
      feeNote: "",
    };
  }

  return {
    ...claim,
    appearanceType,
    feeType: feeInfo.feeType || "",
    feeAmount: feeInfo.amountLabel || "",
    feeTable: feeInfo.table || "",
    feeNote: feeInfo.note || "",
  };
}

function formatRemainingLabel(row) {
  const unit = row.allocationUnit || "item";
  const plural = row.remaining === 1 ? unit : `${unit}s`;
  return `${row.remaining} ${plural} left`;
}

export function formatClaimAvailabilityLabel(row) {
  const feeType = `${row?.feeType || ""}`.toUpperCase();

  if (row?.allocationUnit === "lump sum") {
    return "Lump sum";
  }

  if (row?.allocationUnit === "limit" || feeType === "FOI/TITLE LODG/SEARCH FEE" || feeType === "SERVICE/FILING/COND MONEY") {
    return "Maximum limit";
  }

  if (feeType === "TRAVEL FEE" || feeType === "BAIL TRAVEL FEE") {
    return `${row?.allocationCount || 0} km's`;
  }

  if (feeType === "OVERNIGHT FEE" || feeType === "BAIL OVERNIGHT FEE") {
    return `${row?.allocationCount || 0} overnight${row?.allocationCount === 1 ? "" : "s"}`;
  }

  if (feeType === "TAPE TRANSCRIPTION") {
    return `${row?.allocationCount || 0} tape${row?.allocationCount === 1 ? "" : "s"}`;
  }

  if (feeType === "JAIL CONFERENCE") {
    return `${row?.allocationCount || 0} Conference`;
  }

  return `${row?.allocationCount || 0} appearance${row?.allocationCount === 1 ? "" : "s"}`;
}

export function formatClaimFeeLabel(row) {
  const amountLabel = `${row?.amountLabel || ""}`;
  const moneyMatch = amountLabel.match(/\$\d[\d,]*(?:\.\d{2})?/);
  return moneyMatch?.[0] || amountLabel;
}

export function getClaimFeeAmount(row) {
  const amountLabel = `${row?.amountLabel || ""}`;
  const moneyMatch = amountLabel.match(/\$([\d,]+(?:\.\d{2})?)/);
  if (!moneyMatch) return 0;
  return Number(moneyMatch[1].replace(/,/g, "")) || 0;
}

export function formatClaimedToDateLabel(row) {
  const amount = getClaimFeeAmount(row) * (Number(row?.claimed) || 0);
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function getClaimedToDateAmount(row) {
  return getClaimFeeAmount(row) * (Number(row?.claimed) || 0);
}

function outcomeSuggestsMoreOfSameAppearance(claim) {
  const text = `${claim?.outcome || ""} ${claim?.notes || ""}`.toLowerCase();
  return /adj|adjourned|further mention|mention|return|callover|special mention|review/.test(text);
}

export function getSingleSummaryClaimRows() {
  return SINGLE_SUMMARY_APPEARANCE_OPTIONS.map((key) => SINGLE_SUMMARY_APPEARANCE_LOOKUP[key]);
}

function getCountyCourtBreachClaimRows() {
  return COUNTY_COURT_BREACH_CLAIM_ROWS;
}

function getClaimTrackerRowsForAidType(aidTypeList = []) {
  const rows = [];

  // --- Table A: Single Summary (Magistrates'/Children's Court) ---
  if (hasSummarySingleAidType(aidTypeList)) {
    rows.push(...getSingleSummaryClaimRows());
  }

  // --- Table B: Bail — Magistrates'/Children's Court ---
  if (hasBailAidType(aidTypeList)) {
    rows.push(...BAIL_CLAIM_ROWS);
    // Intensive Bail Scheme supervision fee is Children's Court bail only
    if (hasChildrensCourtBailAidType(aidTypeList)) {
      rows.push(...BAIL_TABLE_B_ADDITIONS);
    }
  }

  // --- Table C: Bail — County Court ---
  if (hasCountyCourtBailAidType(aidTypeList)) {
    rows.push(...COUNTY_COURT_BAIL_CLAIM_ROWS);
  }

  // --- Table D: Bail — Supreme Court ---
  if (hasSupremeCourtBailAidType(aidTypeList)) {
    rows.push(...SUPREME_COURT_BAIL_CLAIM_ROWS);
  }

  // --- Table E: Indictable Committal (Magistrates'/Children's Court) ---
  if (hasIndictableCommittalAidType(aidTypeList)) {
    rows.push(...INDICTABLE_COMMITTAL_CLAIM_ROWS);
  }

  // --- Table F(i): Children's Court Indictable (serious matters) ---
  if (hasChildrensCourtIndictableAidType(aidTypeList)) {
    rows.push(...CHILDRENS_COURT_INDICTABLE_CLAIM_ROWS);
  }

  // --- Table F: County Court Indictable ---
  if (hasCountyCourtIndictableAidType(aidTypeList)) {
    rows.push(...COUNTY_COURT_INDICTABLE_CLAIM_ROWS);
  }

  // --- Table F: Supreme Court Indictable ---
  if (hasSupremeCourtIndictableAidType(aidTypeList)) {
    rows.push(...SUPREME_COURT_INDICTABLE_CLAIM_ROWS);
  }

  // --- Table G: County Court Sentence Appeal ---
  if (hasCountyCourtSentenceAppealAidType(aidTypeList)) {
    rows.push(...COUNTY_COURT_SENTENCE_APPEAL_CLAIM_ROWS);
  }

  // --- Table H: County Court Appeal (Conviction + Sentence) ---
  if (hasCountyCourtConvictionAppealAidType(aidTypeList)) {
    rows.push(...COUNTY_COURT_CONVICTION_APPEAL_CLAIM_ROWS);
  }

  // --- Table J (CC): County Court Breach ---
  if (hasCountyCourtBreachAidType(aidTypeList)) {
    rows.push(...getCountyCourtBreachClaimRows());
  }

  // --- Table J (SC): Supreme Court Breach ---
  if (hasSupremeCourtBreachAidType(aidTypeList)) {
    rows.push(...SUPREME_COURT_BREACH_CLAIM_ROWS);
  }

  // --- Table K: Court of Appeal (convicted person) ---
  if (hasCourtOfAppealAidType(aidTypeList)) {
    rows.push(...COURT_OF_APPEAL_CLAIM_ROWS);
  }

  // --- Table K(i): Court of Appeal — DPP ---
  if (hasCourtOfAppealDPPAidType(aidTypeList)) {
    rows.push(...COURT_OF_APPEAL_DPP_CLAIM_ROWS);
  }

  // --- Table K(ii): Interlocutory Appeal ---
  if (hasInterlocutoryAppealAidType(aidTypeList)) {
    rows.push(...INTERLOCUTORY_APPEAL_CLAIM_ROWS);
  }

  // --- Table L: High Court ---
  if (hasHighCourtAidType(aidTypeList)) {
    rows.push(...HIGH_COURT_CLAIM_ROWS);
  }

  // --- Table T (CC): Mental Impairment Act — County Court ---
  if (hasMentalImpairmentCCAidType(aidTypeList) && !hasMentalImpairmentSCAidType(aidTypeList)) {
    rows.push(...MENTAL_IMPAIRMENT_CC_CLAIM_ROWS);
  }

  // --- Table T (SC): Mental Impairment Act — Supreme Court ---
  if (hasMentalImpairmentSCAidType(aidTypeList)) {
    rows.push(...MENTAL_IMPAIRMENT_SC_CLAIM_ROWS);
  }

  // --- Table Y: Chief Examiner / Witness Assistance ---
  if (hasChiefExaminerAidType(aidTypeList)) {
    rows.push(...CHIEF_EXAMINER_CLAIM_ROWS);
  }

  // --- Table Z (CC): Serious Offenders Act — County Court ---
  if (hasSeriousOffendersCCAidType(aidTypeList) && !hasSeriousOffendersSCAidType(aidTypeList)) {
    rows.push(...SERIOUS_OFFENDERS_CC_CLAIM_ROWS);
  }

  // --- Table Z (SC): Serious Offenders Act — Supreme Court ---
  if (hasSeriousOffendersSCAidType(aidTypeList)) {
    rows.push(...SERIOUS_OFFENDERS_SC_CLAIM_ROWS);
  }

  // --- Table A4: Family Violence Protection Act ---
  if (hasFamilyViolenceAidType(aidTypeList)) {
    rows.push(...FAMILY_VIOLENCE_CLAIM_ROWS);
  }

  // --- Table A5: Personal Safety Intervention Orders ---
  if (hasPSIOAidType(aidTypeList)) {
    rows.push(...PSIO_CLAIM_ROWS);
  }

  // --- Psychological assessment (DISB51) ---
  if (hasPsychologicalAidType(aidTypeList)) {
    rows.push(...PSYCHOLOGICAL_CLAIM_ROWS);
  }

  // --- CRSM8 Consolidated Extension uplift ---
  if (hasConsolExtensionAidType(aidTypeList)) {
    rows.push(...CONSOL_EXTENSION_CRSM8_CLAIM_ROWS);
  }

  return rows;
}

function normalizeTrackerValue(value = "") {
  return `${value || ""}`.toUpperCase().replace(/[^A-Z0-9]+/g, "");
}

export function claimMatchesTrackerRow(claim, row) {
  const candidates = [
    claim?.appearanceType,
    claim?.customAppearanceType,
    claim?.feeType,
  ]
    .map(normalizeTrackerValue)
    .filter(Boolean);

  const aliases = [row.appearanceType, row.feeType, ...(row.trackerAliases || [])]
    .map(normalizeTrackerValue)
    .filter(Boolean);

  return candidates.some((candidate) => aliases.includes(candidate));
}

export function getClaimTrackerPreviewRows(planner) {
  return getClaimTrackerRowsForAidType(planner).map((row) => ({
    ...row,
    claimed: 0,
    remaining: row.allocationCount || 0,
    remainingLabel: formatRemainingLabel({ ...row, remaining: row.allocationCount || 0 }),
  }));
}

export function findClaimAvailabilityRow(planner, claim) {
  return getClaimAvailabilityTable(planner).find((row) => claimMatchesTrackerRow(claim, row)) || null;
}

export function getClaimAvailabilityTable(planner) {
  const trackerRows = getClaimTrackerRowsForAidType(planner);
  if (trackerRows.length === 0) {
    return [];
  }

  const claimedCounts = new Map();
  for (const claim of planner?.appearanceClaims || []) {
    const matchedRow = trackerRows.find((row) => claimMatchesTrackerRow(claim, row));
    if (!matchedRow) continue;
    
    let claimAmount = 1;
    if (matchedRow.allocationUnit === "kilometre" && claim.claimedUnits) {
      claimAmount = Number(claim.claimedUnits) || 0;
    }
    
    claimedCounts.set(matchedRow.feeType, (claimedCounts.get(matchedRow.feeType) || 0) + claimAmount);
  }

  return trackerRows.map((row) => {
    const claimed = claimedCounts.get(row.feeType) || 0;
    const remaining = Math.max(0, (row.allocationCount || 0) - claimed);
    return {
      ...row,
      claimed,
      remaining,
      remainingLabel: formatRemainingLabel({ ...row, remaining }),
    };
  });
}

export function getClaimRowWarning(claim, availabilityRow) {
  if (!claim?.claimLodged || !availabilityRow) return "";
  if (availabilityRow.remaining > 1) return "";
  if (!outcomeSuggestsMoreOfSameAppearance(claim)) return "";
  return "Consider lodging an extension for additional non defend days";
}
